import { styled, Stack, Chip, Typography } from "@mui/material";
import AssetThumbnail, { AssetThumbnailProps } from "../../Misc/AssetThumbnail";

export type TableCellAssetProps = {
  data: {
    row: {
      type: AssetThumbnailProps["type"];
      typeHide?: boolean;
      title: string;
      desc: string;
      onlyPicto?: boolean;
    };
  };
};

const TableCellAsset: React.FC<TableCellAssetProps> = (props) => {
  const { data } = props;
  return (
    <StyledTableCellAsset spacing={1} direction="row" alignItems="center" position="relative" gap={1}>
      {!data?.row?.typeHide && <AssetThumbnail type={data?.row?.type} size="micro" sx={{ flexShrink: 0 }} />}
      <Stack overflow="hidden" gap={0.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1} pr={3}>
          <Typography variant="body1" title={data?.row?.title} fontWeight={500}>
            {data?.row?.title}
          </Typography>

          {data?.row?.typeHide || data?.row?.onlyPicto ? (
            <></>
          ) : (
            <Chip label={data?.row?.type} title={data?.row?.type} color="primary" variant="outlined" size="small" />
          )}
        </Stack>
        <Typography title={data?.row?.desc} variant="body2" color="text.tier">
          {data?.row?.desc}
        </Typography>
      </Stack>
    </StyledTableCellAsset>
  );
};

export default TableCellAsset;

const StyledTableCellAsset = styled(Stack)(({ theme }) => ({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  "&:after": {
    content: '""',
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    width: 40,
    //background: `linear-gradient(270deg, ${theme.palette.background.default} 0%, rgba(14, 14, 27, 0) 100%)`,
  },
  ".MuiChip-root": {
    position: "relative",
    zIndex: 1,
  },
}));
